import React from 'react';

import { Box } from '@chakra-ui/react';

import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';

export const S3AccessPolicies = () => {
  const columns = [
    { header: <Box pl={10}>Path</Box>, accessor: 'name' },
    { header: 'Roles', accessor: 'role' },
    { header: 'Permissions', accessor: 'permissions' },
    { header: 'Masking Policy', accessor: '' },
    { header: 'Actions', accessor: '' },
  ];

  return (
    <Box flex={1} h="full" w="full">
      <Table columns={columns} data={[]} />
    </Box>
  );
};
